export default __webpack_public_path__ + "static/media/login_bg.cfb3e587.jpg";